import { createEpic } from '../helpers';
import { faqGetFaqsAsyncAction } from './faqActions';

export const getFaqEpic = createEpic(
	faqGetFaqsAsyncAction,
	'faq',
	'getFaqs',
	true
);
